import { all } from "redux-saga/effects";
import { chuongTrinhDaoTaoSaga } from "./chuongTrinhDaoTaoSaga";
import { chuongTrinhDaoTaoChiTietSaga } from "./chuongTrinhDaoTaoChiTietSaga";
import { chuongTrinhDaoTaoKienThucSaga } from "./chuongTrinhDaoTaoKienThucSaga";
import { chuongTrinhDaoTaoRangBuocSaga } from "./chuongTrinhDaoTaoRangBuocSaga";
import { chuongTrinhDaoTaoSoSanhSaga } from "./chuongTrinhDaoTaoSoSanhSaga";

export default function* chuongTrinhDaoTaoSagaWrapper() {
  yield all([
    chuongTrinhDaoTaoSaga(),
    chuongTrinhDaoTaoChiTietSaga(),
    chuongTrinhDaoTaoKienThucSaga(),
    chuongTrinhDaoTaoRangBuocSaga(),
    chuongTrinhDaoTaoSoSanhSaga(),
  ]);
}
